import { render, staticRenderFns } from "./ReadEdit.vue?vue&type=template&id=6e8536b6&scoped=true"
import script from "./ReadEdit.vue?vue&type=script&lang=js"
export * from "./ReadEdit.vue?vue&type=script&lang=js"
import style0 from "./ReadEdit.vue?vue&type=style&index=0&id=6e8536b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8536b6",
  null
  
)

export default component.exports